// extracted by mini-css-extract-plugin
module.exports = {"section":"NotFound_section__EsgIf","bordered":"NotFound_bordered__mPRWm","wrap":"NotFound_wrap___rix9"};
module.exports.__checksum = "4af92c441885"
